import React, { useEffect } from 'react';
import RequestList from './components/requestList';
/* import Slide from "@mui/material/Slide"; */
import Dialog from '@mui/material/Dialog';

import { Divider } from '@mui/material';

import i18n from '../../../../utils/i18n';
//REDUX
import { useSelector, useDispatch } from 'react-redux';

import RequestDialog from './components/requestDialog';

import classes from './ClientSection.module.scss';

/* const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
}); */

const requestSortingHelper = [
	{ label: i18n.t('provider.openreqs'), id: 'open' },
	{ label: i18n.t('provider.modifiedreqs'), id: 'modified' },
	{ label: i18n.t('provider.acceptedreqs'), id: 'accepted' },
	{ label: i18n.t('provider.declinedreqs'), id: 'declined' },
	{ label: i18n.t('provider.confirmedreqs'), id: 'confirmed' },
	{ label: i18n.t('provider.rejectedreqs'), id: 'rejected' },
];

const displayRequestLists = (requests, handleSelect) => {
	let reqLists = [];
	requestSortingHelper.forEach((item, i) => {
		if (requests.reqSorted[item.id].length > 0) {
			reqLists.push(
				<RequestList
					title={item.label}
					data={requests.reqSorted[item.id]}
					status={item.id}
					handleSelect={handleSelect}
					key={i}
				/>
			);
		}
	});
	return reqLists;
};
const ClientsSection = ({ ...props }) => {
	const [open, setOpen] = React.useState(false);
	const [selectedReq, setSelectedReq] = React.useState({});
	const reqInfo = useSelector((state) => state.reqInfo);

	const handleSelect = (data) => {
		/*   console.log('parent data data', data); */
		setSelectedReq(data);
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div className={classes.dashboard}>
			<Dialog
				open={open}
				disableEscapeKeyDown={true}
				sx={{
					'& .MuiDialog-container': {
						'& .MuiPaper-root': {
							//width: '1000px',
							maxWidth: '100%',
						},
					},
				}}>
				<RequestDialog
					data={selectedReq}
					handleClose={handleClose}
					updateRequests={props.updateRequests}
				/>
			</Dialog>
			<div className={classes.title}>{i18n.t('general.requests')}</div>
			<Divider />
			<div className={classes.requestsContainer}>
				{displayRequestLists(reqInfo, handleSelect)}
			</div>
		</div>
	);
};

export default ClientsSection;
